import { SVG_BY_EXTENSION } from "@/lib/file-icons-data"

// Extension → public SVG path. Source of truth for scripts/generate-file-icon-svgs.mjs,
// which inlines each file's markup into file-icons-data.ts at build time — keep this
// map and that generated file in sync by re-running the script after editing it.
export const EXT_TO_ICON_PATH: Record<string, string> = {
  pdf: "/im_pdf.svg",
  doc: "/im_doc.svg",
  docx: "/im_doc.svg",
  xls: "/im_xsl.svg",
  xlsx: "/im_xsl.svg",
  ppt: "/im_ppt.svg",
  pptx: "/im_ppt.svg",
  csv: "/im_csv.svg",
  tex: "/im_tex.svg",
  zip: "/im_zip.svg",
  rar: "/im_rar.svg",
  mp3: "/im_mp3.svg",
  mp4: "/im_mp4.svg",
  avi: "/im_avi.svg",
  wav: "/im_wav.svg",
  html: "/im_html.svg",
  json: "/im_json.svg",
  js: "/im_js.svg",
  java: "/im_java.svg",
  md: "/im_md.svg",
  xml: "/im_xml.svg",
  sql: "/im_sql.svg",
  svg: "/im_svg.svg",
  txt: "/im_txt.svg",
  png: "/im_png.svg",
  jpg: "/im_jpg.svg",
  jpeg: "/im_jpg.svg",
  gif: "/im_gif.svg",
  tiff: "/im_tiff.svg",
  tif: "/im_tiff.svg",
  pub: "/im_pub.svg",
  mdb: "/im_mdb.svg",
  exe: "/im_exe.svg",
  dll: "/im_dll.svg",
}

// SVG markup is inlined at build time (see file-icons-data.ts), so this is
// just a resolved-promise wrapper kept for API compatibility with callers.
export function loadSvgByExtension(): Promise<Record<string, string>> {
  return Promise.resolve(SVG_BY_EXTENSION)
}
